module.exports = __webpack_public_path__ + "01_glasses_red.81f3ff79.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer4/01_glasses_red.png
// module id = jsng
// module chunks = 0